module.exports = __webpack_public_path__ + "img/8.0bc9cf78.png";